"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.broadcastTxn = exports.getTxnExpirationDate = exports.getTxnMetadata = exports.signICPTransaction = exports.getUnsignedTransaction = void 0;
const ledger_icp_1 = __importDefault(require("@zondax/ledger-icp"));
const api_1 = require("../api");
const utils_1 = require("./utils");
const agent_1 = require("@dfinity/agent");
const principal_1 = require("@dfinity/principal");
const utils_2 = require("../../../utils");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const getUnsignedTransaction = (transaction, account) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const ops = (0, utils_1.generateOperations)(transaction, account);
    const pubkeys = [
        {
            hex_bytes: (_a = account.xpub) !== null && _a !== void 0 ? _a : "",
            curve_type: "secp256k1",
        },
    ];
    const reqOpts = Object.assign(Object.assign({}, (0, api_1.getICPRosettaNetworkIdentifier)()), { operations: ops, public_keys: pubkeys, metadata: {
            memo: parseInt((_b = transaction.memo) !== null && _b !== void 0 ? _b : "0"),
        } });
    const { payloads, unsigned_transaction } = yield (0, api_1.constructionInvoke)(reqOpts, "payloads");
    return { unsignedTxn: unsigned_transaction, payloads };
});
exports.getUnsignedTransaction = getUnsignedTransaction;
const signICPTransaction = ({ unsignedTxn, transport, path, payloads, pubkey, }) => __awaiter(void 0, void 0, void 0, function* () {
    var _c;
    const icp = new ledger_icp_1.default(transport);
    const decodedTxn = agent_1.Cbor.decode(Buffer.from(unsignedTxn, "hex"));
    const txnReqFromCbor = decodedTxn.updates[0][1];
    const expiry = new utils_1.ingressExpiry((0, bignumber_js_1.default)(decodedTxn.ingress_expiries[0].toString()));
    const submitReq = {
        request_type: "call",
        canister_id: principal_1.Principal.fromUint8Array(txnReqFromCbor.canister_id),
        method_name: txnReqFromCbor.method_name,
        arg: txnReqFromCbor.arg,
        sender: principal_1.Principal.fromUint8Array(txnReqFromCbor.sender),
        ingress_expiry: expiry,
    };
    const txnBlobToSign = agent_1.Cbor.encode({
        content: submitReq,
    });
    const signedTxnRes = yield icp.sign(path, Buffer.from(txnBlobToSign), 0);
    (0, utils_2.isError)(signedTxnRes);
    const result = {
        signatures: {
            readSig: "",
            txnSig: Buffer.from((_c = signedTxnRes.signatureRS) !== null && _c !== void 0 ? _c : "").toString("hex"),
        },
    };
    const signaturesPayload = (0, utils_1.generateSignaturesPayload)(result.signatures, payloads, pubkey);
    const { signed_transaction: signedTxn } = yield (0, api_1.constructionInvoke)(Object.assign(Object.assign({}, (0, api_1.getICPRosettaNetworkIdentifier)()), { signatures: signaturesPayload, unsigned_transaction: unsignedTxn }), "combine");
    return Object.assign(Object.assign({}, result), { signedTxn });
});
exports.signICPTransaction = signICPTransaction;
const getTxnMetadata = (signedTxn) => __awaiter(void 0, void 0, void 0, function* () {
    const { transaction_identifier: { hash }, } = yield (0, api_1.constructionInvoke)(Object.assign(Object.assign({}, (0, api_1.getICPRosettaNetworkIdentifier)()), { signed_transaction: signedTxn }), "hash");
    return { hash };
});
exports.getTxnMetadata = getTxnMetadata;
const getTxnExpirationDate = (_unsignedTxn) => {
    return new Date();
};
exports.getTxnExpirationDate = getTxnExpirationDate;
const broadcastTxn = (signedTxn) => __awaiter(void 0, void 0, void 0, function* () {
    yield (0, api_1.constructionInvoke)(Object.assign(Object.assign({}, (0, api_1.getICPRosettaNetworkIdentifier)()), { signed_transaction: signedTxn }), "submit");
});
exports.broadcastTxn = broadcastTxn;
//# sourceMappingURL=index.js.map